export class AjaxLoadIndicator {
  targetId: string;

  public static getDefault(): AjaxLoadIndicator {
    return new AjaxLoadIndicator('global');
  }

  constructor(targetId: string) {
    this.targetId = targetId;
  }
}
